import React, {Component} from 'react';
import {Row, Col, Card, Input, Button} from 'react-materialize';

import ic_launcher_round from '../../images/ic_launcher_round.png';

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import {injectIntl, intlShape} from 'react-intl';

import {FacebookShareButton, LinkedinShareButton, TwitterShareButton, TelegramShareButton, WhatsappShareButton} from "react-share";
import {FacebookShareCount} from "react-share";
import {FacebookIcon, LinkedinIcon, TwitterIcon, TelegramIcon, WhatsappIcon} from "react-share";

/*
aquassaude@gmail.com
*/

class Contato extends Component{

    render(){

        const url= "https://aquasafeweb.web.app";

        return(

    <Card>

        <Row>
            <div className={"text-center"} align="center">
                <img src={ic_launcher_round} className={"img"} alt={"Aquasafe logo"} width={"200"} height={"200"}/>
            </div>
        </Row>

        <br/>

        <Row>
            <div align="center">
                <h5><b><FormattedMessage id={"contact"} defaultMessage={"FALE CONOSCO"}/></b></h5>
            </div>
        </Row>

        <Row>

            <form action={"https://formspree.io/aquassaude@gmail.com"} method={"POST"}>
                <input type={"text"} name={"name"} placeholder={"Digite sua mensagem"}/>
                <input type={"email"} name={"_replyto"} placeholder={"Email"}/>
                    <input type={"submit"} style={{backgroundColor: '#1e88e5', color: 'white'}} value={"OK"} className={"margin"}/>
                </form>
{/*          <Input placeholder={"Seu email"} type={"email"} label={"Email"} s={12}/>
            <Input placeholder={"Teste..."} label={"Mensagem"} s={12}/>

            <Col s={12} m={12}>
                <Button waves='light' className="right blue darken-2">ENVIAR</Button>
            </Col> */}
        </Row>

        <Row>
            <div align="center">
                <h5><b><FormattedMessage id={"share"} defaultMessage={"COMPARTILHE O AQUASAFE WEB"}/></b></h5>
            </div>

            <div align={"center"}>
            <div className={"margin-share"} style={{display: 'inline-flex', alignItems: 'center'}} >

                <FacebookShareButton url={url}> <FacebookIcon size={60} round={true}/> </FacebookShareButton>
                <LinkedinShareButton url={url}> <LinkedinIcon size={60} round={true}/> </LinkedinShareButton>
                <TwitterShareButton url={url}> <TwitterIcon size={60} round={true}/> </TwitterShareButton>
                <TelegramShareButton url={url}> <TelegramIcon size={60} round={true}/> </TelegramShareButton>
                <WhatsappShareButton url={url}> <WhatsappIcon size={60} round={true}/> </WhatsappShareButton>


            </div> </div>
        </Row>
    </Card> )
    }
}

export default injectIntl(Contato);




